import React from 'react'
import { Row, Table } from 'reactstrap'
import { useTranslation } from 'react-i18next'

const ArtistsCampaigns: React.FunctionComponent = () => {
  const { t } = useTranslation()

  return (
    <Table responsive striped style={{ overflow: 'hidden' }}>
      <thead>
        <tr>
          <th style={{ width: '30%', textAlign: 'center' }} />
          <Row>
            <th style={{ width: '25%' }}>{t('analytics.created')}</th>
            <th style={{ width: '25%' }}>{t('analytics.revenue')}</th>
            <th style={{ width: '19%' }}>{t('analytics.share')}</th>
            <th style={{ width: '29%' }}>{t('analytics.averagePayment')}</th>
          </Row>
        </tr>
      </thead>
      <tbody />
    </Table>
  )
}

export default ArtistsCampaigns
